import { ButtonBase, Stack, Typography } from "@mui/material";
import { background, text } from "@/theme/colors";

type TFilterOption<T extends string> = {
  value: T;
  label: string;
};

type TExamSummaryTabsProps<T extends string> = {
  value: T;
  onChange: (value: T) => void;
  options: TFilterOption<T>[];
};

/** Pill-shaped filter tabs */
export const ExamSummaryTabs = <T extends string>({
  value,
  onChange,
  options,
}: TExamSummaryTabsProps<T>) => {
  return (
    <Stack
      direction="row"
      role="tablist"
      height={45}
      p={0.5}
      bgcolor={background.disable}
      borderRadius="999px"
      gap={0.5}
    >
      {options.map((option) => {
        const isSelected = value === option.value;
        return (
          <ButtonBase
            key={option.value}
            role="tab"
            aria-selected={isSelected}
            onClick={() => onChange(option.value)}
            sx={{
              fontFamily: '"Noto Sans JP", sans-serif',
              flex: 1,
              borderRadius: "999px",
              bgcolor: isSelected ? background.white : "transparent",
              px: 2,
              transition: "background-color 0.2s",
              userSelect: "none",
            }}
          >
            <Typography
              variant="body14"
              fontWeight={isSelected ? 500 : 400}
              color={isSelected ? text.primary : text.secondary}
              textAlign="center"
              whiteSpace="nowrap"
            >
              {option.label}
            </Typography>
          </ButtonBase>
        );
      })}
    </Stack>
  );
};
